import { useQuery } from "@tanstack/react-query";
import { globalSearch } from "../api/search-api";
import type { GlobalSearchResponse } from "../types/search.types";

export function useGlobalSearch(q: string, enabled: boolean, limit = 5) {
  return useQuery<GlobalSearchResponse>({
    queryKey: ["global-search", q, limit],
    queryFn: () => globalSearch(q, limit),
    // Empty q = recent items; 1-char queries are rejected by the backend.
    enabled: enabled && q.length !== 1,
    staleTime: 30_000,
    placeholderData: (prev) => prev,
  });
}
